import { ANIMATION_IDENTIFIERS } from '@Animation/types'
import { DataFetchingState } from '@AppState/types.ts'

export type AppSettingsState = {
  fetchState: DataFetchingState
  menuOpen: boolean
  synced: boolean
  appSettings: AppSettings
}

export type AppSettings = {
  animationsEnabled: AnimationEnabled[]
  autoPlay: boolean
  gameSpeed: GAME_SPEED
  soundEnabled: boolean
}

export type AnimationEnabled = {
  identifier: ANIMATION_IDENTIFIERS
  isEnabled: boolean
}

export enum GAME_SPEED {
  SLOW = 0.5,
  NORMAL = 1,
  FAST = 1.5,
}
